import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/tabbox/icon-more.png'
import _imports_1 from '@/assets/image/icon/check2.png'
import _imports_2 from '@/assets/image/icon/go.png'


const _withScopeId = n => (_pushScopeId("data-v-c470488a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = ["src", "data-src", "onClick"]
const _hoisted_3 = { class: "main" }
const _hoisted_4 = {
  class: /*#__PURE__*/_normalizeClass({ 'main-header': true })
}
const _hoisted_5 = { class: "main-header-search__select" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "tabbox"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多服务", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "company card" }
const _hoisted_14 = {
  key: 0,
  class: "company-info"
}
const _hoisted_15 = { class: "company-info__name" }
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "company-info__name" }, "添加企业 立享服务", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "company-info__content" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon-check",
    src: _imports_1
  }),
  /*#__PURE__*/_createElementVNode("span", null, "开公司上中财捷 经营老板的财税·企业·生活")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "company-info__btn" }, "添加企业", -1))
const _hoisted_20 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "banner2" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "category" }
const _hoisted_24 = { class: "category-item-header" }
const _hoisted_25 = { class: "category-item-header__title" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["src", "onClick"]
const _hoisted_28 = {
  key: 0,
  class: "sticky-placeholder-padding"
}

import { ref, reactive, onMounted, onActivated } from 'vue'
import { useRouter } from 'vue-router'
import { Swipe, SwipeItem, Tabs, Tab, Sticky, List } from 'vant'
import MTabbar from '@/components/MTabbar/MTabbar.vue'
import MWaterFall3 from '@/views/components/MWaterFall3/MWaterFall.vue'
import MSearch from '@/views/components/MSearch/MSearch.vue'
import MNoData2 from '@/views/components/MNoData2/MNoData2.vue'
import PopEquityPackage from '@/views/components/PopEquityPackage/PopEquityPackage.vue'
import FocusOnCode from '@/views/components/FocusOnCode/FocusOnCode.vue'
import FooterTips from '@/views/components/FooterTips/FooterTips.vue'
import {
  getHomeBanner,
  getHomePageIcon,
  getUserIsSubscribe,
  getHomePageRecommend,
} from '@/api/home'
import {
  getGoodsRecommendType,
  getGoodsList,
  getGoodsTypeBoutique,
} from '@/api/goods'

import { useRegionStore } from '@/store/modules/region'
import { useUserStore } from '@/store/modules/user'
import Storage from '@/utils/Storage'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const router = useRouter()
const regionStore = useRegionStore()
const userStore = useUserStore()
const RESOURCES_URL = process.env.VUE_APP_RESOURCES_URL
const RECOMMEND_TYPE = {
  1: {
    name: '课程推荐',
    path: '/video-list',
    query: {},
  },
  2: {
    name: '优质资源',
    path: '/resource-list',
    query: {},
  },
  3: {
    name: '推荐话题',
    path: '/popular-articles',
    query: { pageType: 2 },
  },
  4: {
    name: '推荐资讯',
    path: '/popular-articles',
    query: { pageType: 1 },
  },
}

const scrollContainer = ref(null)
const waterFallContainerRef = ref(null)
const goodsRecommendType = ref(null)
const goodsTabsRef = ref(null)
const isFocusOn = ref(false)
const state = reactive({
  images: [],
  images2: {},
  icons: [],
  searchValue: '',
  tabsActive: 0,
  goodsList: [],
  categoryList: [],
  pageRecommend: [],
  pagination: {
    pageNum: 1,
    pageSize: 10,
  },
  loading: false,
  finished: false,
  waterFallHeight: 0,
  waterFallScroll: null,
  listRenderEnd: false, // 列表加载状态 控制初始状态时空占位符的出现时机
  saveScrollTop: 0, // 记录滚动高度
  cacheListData: {},
  isInFixedLayout: false, // 是否为粘性布局状态
})

onActivated(() => {
  scrollContainer.value.scrollTop = state.saveScrollTop
})

onMounted(async () => {
  fetchHomePageIcon()
  fetchHomeBanner()
  fetchHomeBanner2()
  fetchHomePageRecommend()
  await userStore.getUserInfo()
  fetchUserIsSubscribe()
  regionStore.getHistorySelect()
  fetchGoodsTypeBoutique()
  await fetchGoodsRecommendType()
  // 在 page-stack-vue3 无效的情况下 先通过监听来保持滚动高度
  scrollContainer.value.addEventListener('scroll', () => {
    const scrollTop = scrollContainer.value.scrollTop
    state.saveScrollTop = scrollTop
  })
})

const fetchUserIsSubscribe = async () => {
  isFocusOn.value = Storage.get('IS_FOCUS_ON')
  const { ret } = await getUserIsSubscribe()
  if (ret === 100) {
    isFocusOn.value = false
  } else {
    isFocusOn.value = true
  }
  Storage.set('IS_FOCUS_ON', isFocusOn.value)
}
const fetchHomePageIcon = async () => {
  const { dataList = [] } = await getHomePageIcon({ pageNum: 1, pageSize: 10 })
  state.icons = dataList
    .map((item) => ({
      ...item,
      image: `${RESOURCES_URL}${item.iconPic}`,
    }))
    .filter((item, index) => index < 7)
}
const fetchHomeBanner = async () => {
  const { dataList = [] } = await getHomeBanner({ advertisementType: 0 })
  state.images = dataList.map((item) => ({
    ...item,
    image: `${RESOURCES_URL}${item.imgUrl}`,
  }))
}
const fetchHomeBanner2 = async () => {
  const { dataList = [] } = await getHomeBanner({ advertisementType: 1 })
  state.images2 =
    dataList.length > 0
      ? dataList.map((item) => ({
          ...item,
          image: `${RESOURCES_URL}${item.imgUrl}`,
        }))[0]
      : {}
}
const fetchHomePageRecommend = async () => {
  const { dataList } = await getHomePageRecommend()
  state.pageRecommend = dataList.map((item) => ({
    ...item,
    recommendName: RECOMMEND_TYPE[item.recommendType].name,
    path: {
      path: RECOMMEND_TYPE[item.recommendType].path,
      query: RECOMMEND_TYPE[item.recommendType].query,
    },
  }))
}
// const fetchCategoryList = async () => {
//   const { dataList = [] } = await getGoodsType({ showLevel: 1 })
//   if (dataList.length > 0) {
//     state.categoryList = [
//       { title: '推荐', type: '' },
//       ...converData(dataList).map((item) => ({
//         ...item,
//         title: item.goodsTypeName,
//         type: item.id,
//       })),
//     ]
//   }
// }
const fetchGoodsTypeBoutique = async () => {
  const { dataList = [] } = await getGoodsTypeBoutique({
    pageNum: 1,
    pageSize: 20,
  })
  state.categoryList = [
    { title: '为你推荐', type: '' },
    ...dataList
      .filter((item, index) => index < 6)
      .map((item) => ({
        ...item,
        title: item.typeName,
        type: item.id,
      })),
  ]
}
const converData = (list) => {
  return list.map((item) => ({
    ...item,
    text: item.goodsTypeName,
    children: item.list ? converData(item.list) : [],
  }))
}
const fetchGoodsRecommendType = async () => {
  const { data = '' } = await getGoodsRecommendType()
  goodsRecommendType.value = data
}
const fetchGoodsList = async () => {
  let params = {}
  if (state.tabsActive === 0) {
    params = { ...state.pagination, order: goodsRecommendType.value }
  } else {
    params = {
      ...state.pagination,
      id: state.categoryList[state.tabsActive].id,
      cityCode: regionStore.currentSelectRegion?.code,
    }
  }
  const { dataList = [] } = await getGoodsList(params)
  state.listRenderEnd = true
  state.goodsList = [
    ...state.goodsList,
    ...dataList.map((item) => ({
      ...item,
      goodsLables: item.goodsLables ? item.goodsLables.split(',') : [],
      employeeLabel: item.employeeLabel ? item.employeeLabel.split(',') : [],
    })),
  ]
  state.pagination.pageNum++
  state.loading = false
  state.finished = dataList.length === 0
}
const handleRouterLink = (route) => {
  router.push(route)
}
const handleBannerLinkTo = (linkUrl) => {
  location.href = linkUrl
}
const handleBanner2LinkTo = (type, id) => {
  console.log(type, id)
  switch (type) {
    case 1:
      router.push({ path: `/video/course-detail/${id}` })
      break
    case 2:
      router.push({ path: `/resource-detail/${id}` })
      break
    case 3:
      router.push({ path: `/talk-detail/${id}`, query: { detailType: 2 } })
      break
    case 4:
      router.push({ path: `/talk-detail/${id}`, query: { detailType: 1 } })
      break
    default:
      break
  }
}
const onTabChange = async (key) => {
  state.finished = true
  state.listRenderEnd = false
  state.pagination.pageNum = 1
  state.goodsList = []

  const cahceData = state.cacheListData[state.tabsActive]
  const cacheList = cahceData?.list
  const cacheScrollTop = cahceData?.scrollTop

  if (Array.isArray(cacheList)) {
    state.goodsList = [...cacheList]
  }

  await fetchGoodsList()

  if (cacheScrollTop) {
    scrollContainer.value.scrollTop = cacheScrollTop
  } else {
    // 滚动到列表容器顶部
    // 切换tab时，在容器滚动高度超过容器offsetTop时滚动到offsetTop位置
    const thisScrollTop = scrollContainer.value.scrollTop
    const containerScrollTop = goodsTabsRef.value.offsetTop
    // 以375屏宽偏移72px计算出粘性布局其他设备的边界值
    const offsetScale = document.documentElement.offsetWidth - 375
    const offsetValue = ~~(0.36 * offsetScale * 100) / 1e2 + 72
    if (thisScrollTop - offsetValue > containerScrollTop) {
      scrollContainer.value.scrollTop = containerScrollTop + offsetValue
      state.isInFixedLayout = true
    }
  }
}
const onSaveHeight = (height) => {
  if (height > state.waterFallHeight) {
    // state.waterFallHeight = height + 100
  }
}

// 切换tab前缓存列表数据和滚动位置
const handleTabChangeBefore = () => {
  state.cacheListData = {
    ...state.cacheListData,
    [state.tabsActive]: {
      list: state.goodsList,
      scrollTop: scrollContainer.value.scrollTop,
    },
  }
  return true
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "container",
      ref_key: "scrollContainer",
      ref: scrollContainer
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Swipe), {
          class: "header-swipe",
          immediate: true,
          autoplay: 3000
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.images, (item) => {
              return (_openBlock(), _createBlock(_unref(SwipeItem), {
                key: item.image
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: item.image,
                    "data-src": item.image,
                    onClick: ($event: any) => (handleBannerLinkTo(item.linkUrl))
                  }, null, 8, _hoisted_2)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Sticky), null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(MSearch, { isLink: true }, {
                "left-content": _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/region-select" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createTextVNode(_toDisplayString(_unref(regionStore).currentSelectRegion?.name || '地区') + " ", 1),
                        _createElementVNode("img", {
                          src: require('@/assets/image/icon/drop-down.png')
                        }, null, 8, _hoisted_6)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        (state.icons?.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.icons, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.label,
                  class: "tabbox__item",
                  onClick: ($event: any) => (
            handleRouterLink({
              path: '/goods-list',
              query: {
                categoryId: item.goodsTypeId,
                typeLevel: item.level,
                goodsTypeName: item.goodsTypeName,
              },
            })
          )
                }, [
                  _createElementVNode("img", {
                    src: item.image
                  }, null, 8, _hoisted_9),
                  _createElementVNode("span", null, _toDisplayString(item.goodsTypeName), 1)
                ], 8, _hoisted_8))
              }), 128)),
              _createElementVNode("div", {
                class: "tabbox__item",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (handleRouterLink({ path: '/category-list' })))
              }, _hoisted_12)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          (_unref(userStore).userInfo?.bingdCompanyName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_router_link, {
                  class: "ub ub-ac",
                  to: "/lnquire-tax"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(userStore).userInfo?.bingdCompanyName), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", {
                  class: "company-info__btn",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handleRouterLink({ path: '/change-company' })))
                }, [
                  _createElementVNode("img", {
                    src: require('@/assets/image/icon/change-white.png')
                  }, null, 8, _hoisted_16),
                  _createTextVNode("切换 ")
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "company-info",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (handleRouterLink({ name: 'binding-company' })))
              }, _hoisted_20))
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("img", {
            src: state.images2?.image,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (handleBannerLinkTo(state.images2?.linkUrl)))
          }, null, 8, _hoisted_22)
        ]),
        _createElementVNode("div", _hoisted_23, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.pageRecommend, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.title,
              class: "category-item"
            }, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, _toDisplayString(item.recommendName), 1),
                _createElementVNode("img", {
                  class: "category-item-header__icon",
                  src: _imports_2,
                  onClick: ($event: any) => (handleRouterLink(item.path))
                }, null, 8, _hoisted_26)
              ]),
              _createVNode(_unref(Swipe), {
                class: "category-swipe",
                autoplay: 3000
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.recomments, (itemInfo) => {
                    return (_openBlock(), _createBlock(_unref(SwipeItem), {
                      key: itemInfo.coverPicture
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: _unref(RESOURCES_URL) + itemInfo.coverPicture,
                          onClick: ($event: any) => (
                  handleBanner2LinkTo(item.recommendType, itemInfo.targetId)
                )
                        }, null, 8, _hoisted_27)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", {
          ref_key: "goodsTabsRef",
          ref: goodsTabsRef,
          class: _normalizeClass({ 'tabs-swipe': true }),
          style: _normalizeStyle({ height: `${state.waterFallHeight}px`, minHeight: '100vh' })
        }, [
          _createVNode(_unref(Tabs), {
            active: state.tabsActive,
            "onUpdate:active": _cache[5] || (_cache[5] = ($event: any) => ((state.tabsActive) = $event)),
            swipeable: "",
            sticky: "",
            "offset-top": "60px",
            onChange: onTabChange,
            "before-change": handleTabChangeBefore
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.categoryList, (item, index) => {
                return (_openBlock(), _createBlock(_unref(Tab), {
                  title: item.title,
                  key: item.title,
                  style: { paddingBottom: '50px' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(List), {
                      loading: state.loading,
                      "onUpdate:loading": _cache[4] || (_cache[4] = ($event: any) => ((state.loading) = $event)),
                      finished: state.finished,
                      onLoad: fetchGoodsList,
                      style: {
                paddingBottom: '50px',
                marginTop: '4px',
              }
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          ref_for: true,
                          ref_key: "waterFallContainerRef",
                          ref: waterFallContainerRef
                        }, [
                          (state.isInFixedLayout)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28))
                            : _createCommentVNode("", true),
                          (state.tabsActive === index)
                            ? (_openBlock(), _createBlock(MWaterFall3, {
                                key: 1,
                                listData: state.goodsList,
                                onOnSendHeight: onSaveHeight
                              }, null, 8, ["listData"]))
                            : _createCommentVNode("", true),
                          (state.goodsList.length === 0 && state.listRenderEnd)
                            ? (_openBlock(), _createBlock(MNoData2, {
                                key: 2,
                                class: "delay-no-data"
                              }))
                            : _createCommentVNode("", true),
                          (state.goodsList.length != 0)
                            ? (_openBlock(), _createBlock(FooterTips, { key: 3 }))
                            : _createCommentVNode("", true)
                        ], 512)
                      ]),
                      _: 2
                    }, 1032, ["loading", "finished"])
                  ]),
                  _: 2
                }, 1032, ["title"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["active"])
        ], 4)
      ]),
      _createVNode(MTabbar)
    ], 512),
    _createVNode(PopEquityPackage),
    _createVNode(FocusOnCode)
  ], 64))
}
}

})